import React from 'react';
import './isaTransferSection.scss';
import { useUnifiedAnalytics } from '../../../contexts/AnalyticsWrapper';
import upArrow from '../../../assets/images/isa-transfer-up-arrow.svg';
import downArrow from '../../../assets/images/isa-transfer-down-arrow.svg';
import arrowsGraphic from '../../../assets/images/isa-transfer-arrows.svg';
import withFeatureFlags from '../../FeatureFlags/withFeatureFlags';
/** @import {WithFeatureFlagsProps} from '../../FeatureFlags/FeatureFlagsTypes' */

const IsaTransferSection = (/** @type {WithFeatureFlagsProps} */ { featureEnabled }) => {
    const analytics = useUnifiedAnalytics();
    const secondaryAccTransferDisabled = typeof featureEnabled === 'function' ? featureEnabled('SecondaryAccountFISATransferDisabled') : true;
    const handleTransferClick = () => {
        if (analytics) {
            analytics.trackAnalyticsClickEvent(
                'isa transfer section cta click',
                '/new-account/fisa/isa-transfer',
                '',
                '',
                '',
                {},
                'button click',
                'ISA_Transfer_Section|Button_Click|Transfer_Your_ISA',
                'ISA Transfer Section'
            );
        }
        window.location.href = '/new-account/fisa/isa-transfer';
    };

    return (
        <section className="isa-transfer-section">
            <div className="isa-transfer-section__container">
                {/* Desktop: full-height arrows graphic column */}
                <div className="isa-transfer-section__graphic">
                    <img src={upArrow} className="isa-transfer-section__graphic-up" alt="" aria-hidden="true" />
                    <img src={downArrow} className="isa-transfer-section__graphic-down" alt="" aria-hidden="true" />
                </div>
                <div className="isa-transfer-section__content">
                    <div className="isa-transfer-section__text-group">
                        {/* Mobile: heading row with combined arrows graphic; hidden on desktop */}
                        <div className="isa-transfer-section__heading-row">
                            <img src={arrowsGraphic} className="isa-transfer-section__graphic-inline" alt="" aria-hidden="true" />
                            <h2 className="isa-transfer-section__heading">
                                Transfer your Cash ISA to Investec Save
                            </h2>
                        </div>
                        <div className="isa-transfer-section__body">
                            <p>To transfer a cash ISA to us, you&apos;ll need to open an Investec Cash ISA first.</p>
                            <p>You&apos;ll also need the sort code and account number, and/or roll number, for your existing cash ISA.</p>
                            <p>Check any fees, notice periods or transfer limits with your current provider before you start.</p>
                        </div>
                    </div>
                    {/* Mobile/tablet: shorter label; desktop: full label */}
                    <button className="isa-transfer-section__cta" onClick={secondaryAccTransferDisabled ? undefined : handleTransferClick} disabled={secondaryAccTransferDisabled}>
                        <span className="isa-transfer-section__cta-label--mobile">
                            Transfer your ISA
                        </span>
                        <span className="isa-transfer-section__cta-label--desktop">Transfer your cash ISA</span>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default withFeatureFlags(IsaTransferSection);
